<div style="padding: 1em;">
  <ion-label>{{description}}</ion-label>
</div>

 

